import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

//#region coursestatus store
let store = (set) => ({
  // store coursestatus
  coursestatus: {},
  // get All coursestatus
  getcoursestatus: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/coursestatus`, config)
    set(async (state) => {
      // initilize coursestatus state variable to the responsed coursestatus if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.coursestatus = apiResponse.data
    })
  },
  getcoursestatusBaseOnMajor: async (major, cohort) => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      // params: {
      //   sortBy: 'coursestatus.id',
      //   orderBy: 'desc',
      // }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/coursestatus/rank/all?major=${major}&cohort=${cohort}`, config)
    set(async (state) => {
      // initilize coursestatus state variable to the responsed coursestatus if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.coursestatusBaseOnMajor = apiResponse.data
    })
  },
  addcoursestatus: async (payload) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.post(`${process.env.REACT_APP_API}/coursestatus`, payload, config)
    if (apiResponse?.status === 201) {
      set(async (state) => {
        // initilizing coursestatus state variable to the resoponsed data
        state.coursestatus = {
          data: [apiResponse.data, ...state.coursestatus.data],
          limit: state.coursestatus.limit,
          page: state.coursestatus.page,
          totalCount: state.coursestatus.totalCount + 1,
        }
      })
    }
    return apiResponse
  },
  editcoursestatus: async (payload, id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.patch(`${process.env.REACT_APP_API}/coursestatus/${id}`, payload, config)
    // update coursestatus state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const result = state.coursestatus?.data?.find((coursestatus, index) => {

          if (coursestatus.id === id) {
            state.coursestatus.data[index] = apiResponse?.data
          }
        })

        state.coursestatus = {
          data: [...state.coursestatus.data],
          limit: state.coursestatus.limit,
          page: state.coursestatus.page,
          totalCount: state.coursestatus.totalCount,
        }
      })
    }
    return apiResponse
  },
  deletecoursestatus: async (id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.delete(`${process.env.REACT_APP_API}/coursestatus/${id}`, config)
    // delete element in the coursestatus.data array state if the request was succeed
    if (apiResponse?.status === 200) {

      set(async (state) => {
        const arr = state.coursestatus.data.filter(item => item.id !== id)
        state.coursestatus = {
          data: arr,
          limit: state.coursestatus.limit,
          page: state.coursestatus.page,
          totalCount: state.coursestatus.totalCount - 1,
        }
      })

    }

    return apiResponse

  },
})
//#endregion coursestatus store

// store the state in the browser local storage
// store = persist(store, { name: 'coursestatus' })

// getting store data in the browser localstorage
const coursestatus_Store = create(store)

export default coursestatus_Store
